if (!customElements.get('af-cart-offer')) {
  customElements.define('af-cart-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('select');
      this.button = this.querySelector('button');
      this.addEventListener('change', event => { event.stopPropagation(); this.updatePrice(); });
      this.button.addEventListener('click', () => this.add());
      this.updatePrice();
    }
    updatePrice() {
      const selected = this.select.selectedOptions[0];
      const image = this.querySelector('.af-cart-offer__image');
      if (image && selected?.dataset.image) {
        image.removeAttribute('srcset');
        image.src = selected.dataset.image;
        image.alt = this.querySelector('strong').textContent + ' – ' + selected.textContent;
      }
      const price = Number(selected?.dataset.price);
      const base = Number(this.dataset.base);
      const total = this.dataset.kind === 'headband' ? base + price - 2000 : Math.round(base * .9) + Math.round(price * .9);
      const money = cents => 'CHF ' + (cents / 100).toFixed(2);
      this.querySelector('[data-offer-price]').textContent = '+ ' + money(total - Number(this.dataset.current));
      this.querySelector('[data-offer-total]').textContent = (this.dataset.kind === 'headband' ? '2 Stirnbänder' : '2 Paar') + ' zusammen: ' + money(total);
      this.button.disabled = !this.select.value;
    }
    async add() {
      if (this.button.disabled) return;
      const drawer = this.closest('cart-drawer');
      const error = this.querySelector('[role="alert"]');
      this.button.disabled = true;
      this.button.textContent = 'Wird hinzugefügt …';
      this.setAttribute('aria-busy', 'true');
      error.hidden = true;
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.select.value, quantity: 1 }], sections: drawer.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Bitte versuche es erneut.');
        if (!result.sections?.['cart-drawer']) { window.location.assign(window.routes.cart_url); return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(result);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'af-cart-offer', cartData: result });
      } catch (failure) {
        error.textContent = failure.message || 'Bitte prüfe deinen Warenkorb und versuche es erneut.';
        error.hidden = false;
        this.button.disabled = false;
        this.button.textContent = '+ Hinzufügen';
        this.removeAttribute('aria-busy');
      }
    }
  });
}
